export default ({ service, request, serviceForMock, requestForMock, mock, faker, tools }) => ({
    masterFabricCategory_tree (data = {}) {
        return request({
            url: '/digitalCenter/masterFabricCategory/tree',
            method: 'post',
            data
        })
    },
    masterFabricCategory_detail (data = {}) {
        return request({
            url: '/digitalCenter/masterFabricCategory/detail',
            method: 'post',
            data
        })
    },
    masterFabricCategory_save (data = {}) {
        return request({
            url: '/digitalCenter/masterFabricCategory/save',
            method: 'post',
            data
        })
    },
    masterFabricCategory_del (data = {}) {
        return request({
            url: '/digitalCenter/masterFabricCategory/del',
            method: 'post',
            data
        })
    },
})